/**
 * Atualiza o produto com a configuração 'ValorMinimoMensalidade'
 * com o valor da mensalidade calculada (no front)
 * @param {Array} produtos lista de produtos
 * @param {Number} valorMensalidade valor da mensalidade
 */
export function updateProdutoValorMensaliade(produtos, valorMensalidade) {
  produtos.forEach((prod) => {
    if (prod.isValorMinimoMensalidade) {
      prod.valorMensalidade = valorMensalidade;
    }
  });
}

/**
 * Verifica se o produto com a configuração 'ValorMinimoMensalidade'
 * está com o valor inferior a mensalidade.
 * Caso sim, atualiza o produto como valor da mensalidade
 * @param {Array} produtos lista de produtos
 * @param {Number} valorMensalidade valor da mensalidade
 */
export function updateProdutoValorMinimoMensalidade(
  produtos,
  valorMensalidade,
) {
  produtos.forEach((prod) => {
    if (prod.isValorMinimoMensalidade) {
      if (prod.valorFinal == valorMensalidade) {
        return;
      }

      if (prod.valorFinal < valorMensalidade) {
        prod.changeValorMinimoMensalidade = true;

        const valorDesconto = Number(
          Number(prod.valor - valorMensalidade).toFixed(2),
        );
        const descontoConcedido = Number(
          Number((valorDesconto * 100) / prod.valor).toFixed(2),
        );

        if (valorDesconto > 0) {
          prod.idTipoDesconto = 0;
          prod.tipoDesconto = 'Desconto por Valor';
          prod.valorDesconto = valorDesconto;
          prod.descontoConcedido = descontoConcedido;
        } else {
          delete prod.idTipoDesconto;
          delete prod.tipoDesconto;
          delete prod.valorDesconto;
          delete prod.style;
          prod.descontoConcedido = 0;
          prod.valor = valorMensalidade;
        }

        prod.valorFinal = valorMensalidade;
      } else {
        if (prod.changeValorMinimoMensalidade) {
          const { valorOriginalBeforeValorMensalidade } = prod;

          if (valorOriginalBeforeValorMensalidade > valorMensalidade) {
            prod.changeValorMinimoMensalidade = false;
            prod.valor = valorOriginalBeforeValorMensalidade;
            prod.valorFinal = valorOriginalBeforeValorMensalidade;
            return;
          }

          prod.valor =
            prod.valor < valorMensalidade ? valorMensalidade : prod.valor;
          prod.valorFinal =
            prod.valorFinal < valorMensalidade
              ? valorMensalidade
              : prod.valorFinal;
        }
      }
    }
  });
}

/**
 * Atualiza o valor final dos produtos de veículo para o valor da mensalidade.
 * @param {Array} propostasProdutos - As propostas de produtos.
 * @param {number} valorMensalidadeRateado - O valor da mensalidade a ser atribuído.
 * @returns {Array} Uma cópia das propostas de produtos com os valores atualizados.
 */
export function veiculoMultiUpdateProdutoValorMinimoMensalidade(
  propostasProdutos,
  valorMensalidadeRateado,
) {
  const copiaPropostasProdutos = [...propostasProdutos];

  copiaPropostasProdutos.forEach((proposta) => {
    proposta.produtosVeiculo.forEach((produtoVeiculo) => {
      if (produtoVeiculo.isValorMinimoMensalidade) {
        produtoVeiculo.valorFinal = valorMensalidadeRateado;
      }
    });
  });

  return copiaPropostasProdutos;
}

/**
 * Atualiza o valor final dos produtos de agregados para o valor da mensalidade.
 * @param {Array} propostasProdutos - As propostas de produtos.
 * @param {number} valorMensalidadeRateado - O valor da mensalidade a ser atribuído.
 * @returns {Array} Uma cópia das propostas de produtos com os valores atualizados.
 */
export function agregadoMultiUpdateProdutoValorMinimoMensalidade(
  propostasProdutos,
  valorMensalidadeRateado,
) {
  const copiaPropostasProdutos = [...propostasProdutos];

  copiaPropostasProdutos.forEach((proposta) => {
    proposta.agregados.forEach((agregado) => {
      agregado.produtosAgregado.forEach((produtoAgregado) => {
        if (produtoAgregado.isValorMinimoMensalidade) {
          produtoAgregado.valorFinal = valorMensalidadeRateado;
        }
      });
    });
  });

  return copiaPropostasProdutos;
}
